import { UnloadPrompt, historyDispatcher } from './callbacks/basic';

/*
 * Project: LegalPlace assistant
 * File: src/app/callbacks.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpCallbacks {
  constructor() {
    this.onResize = null;
    this.onClose = null;
    this.onBeforeClose = null;
    this.onFocus = null;
    this.onBlur = null;
    this.onNextPrevious = null;
    this.changed_callback = '';
    // load things in the bigenning
  }

  addCallback(name, func) {
    if (Object.keys(this).includes(name)) {
      this[name] = func;
      this.changed_callback = name;
      this.updateCallbacks();
    }
  }

  updateCallbacks() {
    switch (this.changed_callback) {
      case 'onResize':
        window.onresize = this.onResize;
        break;
      case 'onClose':
        window.onunload = this.onClose;
        break;
      case 'onBeforeClose':
        window.onbeforeunload = this.onBeforeClose;
        break;
      case 'onFocus':
        window.onfocus = this.onFocus;
        break;
      case 'onBlur':
        window.onblur = this.onBlur;
        break;
      case 'onNextPrevious':
        window.onpopstate = this.onNextPrevious;
        break;
      default:
        break;
    }
  }

  setupInitialCallbacks() {
    this.addCallback('onBeforeClose', UnloadPrompt);
    this.addCallback('onNextPrevious', historyDispatcher);
  }
}

export default LpCallbacks;



// WEBPACK FOOTER //
// ./src/app/callbacks.js